import { StylesConfig } from 'react-select';
import { OptionType } from 'components/CustomSelect/types';

const allocationMethodListStyles: StylesConfig<OptionType, false> = {
  option: styles => ({
    ...styles,
    fontSize: '14px',
    fontWeight: 600,
    textAlign: 'right',
  }),
};

export default allocationMethodListStyles;
